<template>
	<div> 
	<v-list flat color="lightGrey" class="pa-4 rounded-lg">
		<h5 class="cn-font grey--text mb-2">Vorgangsübersicht</h5>
		<v-list-item dense>
			<v-list-item-icon>
				<v-icon>{{typeIcon}}</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>{{mwTranslate('type', collaboration.type)}}</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
		<v-list-item dense>
			<v-list-item-icon>
				<v-icon>mdi-account</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>{{user.display_name}}</v-list-item-title>
				<v-list-item-subtitle>Erhebungsverantwortlicher</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
		<v-list-item dense>
			<v-list-item-icon>
				<v-icon>mdi-calendar</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>
					<DateNote color="black" :date="collaboration.created" format="DD.MM.yyyy"></DateNote>
				</v-list-item-title>
				<v-list-item-subtitle>Erstellt</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
		<v-list-item dense>
			<v-list-item-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>
					<DateNote color="black" :date="collaboration.updated" format="DD.MM.yyyy"></DateNote>
				</v-list-item-title>
				<v-list-item-subtitle>Zuletzt Bearbeitet</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
	</v-list>
	</div>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import DateNote from "@/components/elements/DateNote"
	export default {
		name: "CollaborationOverview", 
		props: {
			id: {type: String }
		},
		data: () => {
			return {

			}
		},
		components: {
			DateNote
		},
		computed: {
			...Vuex.mapState({
				user: state => state.user,
				groups: state => state.groups || [],
				collaborations: state => state.collaborations || [],
			}),
			collaboration(){
				var id = this.id;
				return this.collaborations.find( c => c.id == id )
			}, 
			typeIcon(){
				if( this.collaboration.type == "poll" ){
					return "mdi-account-group"
				}
				return "mdi-clipboard-flow"
			},
			statusColor(){
				if( this.collaboration.status == "in_progress" ){
					return "primary2"
				}
				if( this.collaboration.status == "complete" ){
					return "green"
				}
				return "grey"
			}, 
			completionRateColor(){
				if( this.collaboration.completion_rate > 70 ){
					return "green"
				}
				if( this.collaboration.completion_rate > 30 ){
					return "primary2"
				}
				if( this.collaboration.completion_rate > 30 ){
					return "orange"
				}
				return "grey"
			},
			started(){
				return this.collaboration.status !== "not_started"
			}
		},			// ...Vuex.mapState({})
		// },
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>